module.exports = __webpack_public_path__ + "img/heimler.da5589de.jpg";